export enum LoaderType {
    LOADER_FORM = 'LOADER_FORM',
    LOADER_SUBMIT = 'LOADER_SUBMIT'
}
